import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { useUrlPagination } from '../../shared/hooks/useUrlPagination.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';
import { EmptyState } from '../../shared/ui/EmptyState';
import { LayoutGrid, Plus } from 'lucide-react';

const PAGE_SIZE = 5;

const CategoryOfPortfolioPage = () => {
  const [categories, setCategories] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [searchValue, setSearchValue] = useState(q);
  const [reloadKey, setReloadKey] = useState(0);
  const { page, offset, pageSize, setPage } = useUrlPagination(PAGE_SIZE);

  // Черновик в поле поиска следует за URL (назад/вперёд в браузере)
  useEffect(() => {
    setSearchValue(q);
  }, [q]);

  useEffect(() => {
    let cancelled = false;
    const request = q
      ? apiRequests.portfolio.getCategoriesFiltered(q, pageSize, offset)
      : apiRequests.portfolio.getCategories(pageSize, offset);
    request
      .then((res) => {
        if (!cancelled) setCategories(res);
      })
      .catch((e) => console.error(e));
    return () => {
      cancelled = true;
    };
  }, [q, offset, pageSize, reloadKey]);

  const handleSearch = () => {
    const next = searchValue.trim();
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (next) params.set('q', next);
      else params.delete('q');
      params.delete('page');
      return params;
    });
  };

  const handleDelete = (id) => {
    apiRequests.portfolio.deleteCategory(id).then(() => {
      if (categories.items?.length === 1 && page > 1) setPage(page - 1);
      else setReloadKey((k) => k + 1);
    });
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink="/portfolio/categories/create"
      />

      <div className="mb-3">
        {categories.items?.length === 0 ? (
          q ? (
            <EmptyState
              icon={LayoutGrid}
              variant="search"
              title="Категория не найдена"
              description={`По запросу «${q}» категорий нет. Проверьте написание или создайте новую.`}
            />
          ) : (
            <EmptyState
              icon={LayoutGrid}
              title="Категорий пока нет"
              description="Категория — тип работы в кейсе: сайт, мобильное приложение, CRM. По ней кейсы фильтруются на сайте."
              action={{
                label: 'Добавить категорию',
                to: '/portfolio/categories/create',
                icon: Plus,
              }}
            />
          )
        ) : (
          categories.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[{ label: 'Создано', value: dateToString(item.createdAt) }]}
              editLink={`/portfolio/categories/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        page={page}
        total={categories.totalCount}
        pageSize={pageSize}
        onPageChange={setPage}
      />
    </>
  );
};

export default CategoryOfPortfolioPage;
